export default "__VITE_ASSET__xrl0ThUd__"